import { useTranslation } from "react-i18next";

import {
  colapsedSectionsPropertyNames,
  ICollapsedSection,
  IPatientInfo,
} from "../../../../@types/Patient";
import { ChevronDown } from "../../../../assets/icons/ChevronDown";
import { ChevronUp } from "../../../../assets/icons/ChevronUp";
import { CustomIconButton } from "../../../../components/CustomIconButton";
import useIsMobile from "../../../../hooks/useIsMobile";
import { ChartsContainer } from "../../PatientPage.styles";
import { EcgResultsModal } from "../EcgResultsModal";
import {
  PinnedSectionTitle,
  PinnedTile,
  TitleContainer,
} from "../PinnedSection/PinnedSection.styles";

type PinnedEcgSectionProps = {
  patient: IPatientInfo;
  collapsedSection: ICollapsedSection;
  updateColapsedSections: (section: colapsedSectionsPropertyNames) => void;
};

export function PinnedEcgSection({
  patient,
  collapsedSection,
  updateColapsedSections,
}: PinnedEcgSectionProps) {
  const { t } = useTranslation();

  const { isMobile } = useIsMobile();

  return (
    <>
      {!isMobile && (
        <TitleContainer>
          <PinnedSectionTitle>
            {t("patientPage_sections_pinned")}
          </PinnedSectionTitle>
          <CustomIconButton
            style={{ marginLeft: "2px" }}
            onClick={() => updateColapsedSections("pinnedSection")}
          >
            {collapsedSection?.value ? <ChevronUp /> : <ChevronDown />}
          </CustomIconButton>
        </TitleContainer>
      )}

      <ChartsContainer
        style={{
          height: collapsedSection?.value ? "0" : "",
          overflow: collapsedSection?.value ? "hidden" : "",
        }}
      >
        <PinnedTile>
          <EcgResultsModal patientId={patient.id} isPinned />
        </PinnedTile>
      </ChartsContainer>
    </>
  );
}
